import RouterView from "@/components/ui/RouterView.vue"

function getRoutes(path) {
  const routePrefix = `/ads`

  return {
    path: path,
    component: () => import("@/views/ads/AdEditContainer.vue"),
    props: route => ({
      id: route.params.id || null,
    }),
    children: [
      {
        path: "",
        redirect: "basics",
      },
      {
        path: "basics",
        component: () => import("@/views/ads/edit/AdBasics.vue"),
        meta: {
          nestedMode: true,
          drawerItems,
        },
        props: route => ({
          id: route.params.id || null,
          prevRoute: null,
          nextRoute: `${routePrefix}/${route.params.id || path}/audience`,
        }),
      },
      {
        path: "audience",
        component: RouterView,
        children: [
          {
            path: "",
            redirect: "type",
          },
          {
            path: "type",
            component: () => import("@/views/audiences/edit/AudienceType.vue"),
            meta: {
              title: "Jaké publikum chcete vytvořit?",
              nestedMode: true,
              drawerItems,
            },
            props: route => ({
              id: route.params.id || null,
              prevRoute: `${routePrefix}/${route.params.id || path}/basics`,
              nextRoute: `${routePrefix}/${route.params.id ||
                path}/audience/targeting-basics`,
              storeNamespace: "ads",
            }),
          },
          {
            path: "targeting-basics",
            component: () =>
              import("@/views/audiences/edit/targeting/TargetingBasics.vue"),
            meta: {
              title: "Cílení - Základní údaje",
              nestedMode: true,
              drawerItems,
            },
            props: route => ({
              id: route.params.id || null,
              prevRoute: `${routePrefix}/${route.params.id ||
                path}/audience/type`,
              nextRoute: `${routePrefix}/${route.params.id ||
                path}/audience/targeting-interests`,
              targetingSummaryRoute: `${routePrefix}/${route.params.id ||
                path}/audience/targeting-summary`,
              storeNamespace: "ads",
            }),
          },
          {
            path: "targeting-interests",
            component: () =>
              import("@/views/audiences/edit/targeting/TargetingInterests.vue"),
            meta: {
              title: "Cílení - Zájmy a demografie",
              nestedMode: true,
              drawerItems,
            },
            props: route => ({
              id: route.params.id || null,
              prevRoute: `${routePrefix}/${route.params.id ||
                path}/audience/targeting-basics`,
              nextRoute: `${routePrefix}/${route.params.id ||
                path}/audience/targeting-excluded-interests`,
              storeNamespace: "ads",
            }),
          },
          {
            path: "targeting-excluded-interests",
            component: () =>
              import(
                "@/views/audiences/edit/targeting/TargetingExcludedInterests.vue"
              ),
            meta: {
              title: "Cílení - Vyloučené zájmy a demografie",
              nestedMode: true,
              drawerItems,
            },
            props: route => ({
              id: route.params.id || null,
              prevRoute: `${routePrefix}/${route.params.id ||
                path}/audience/targeting-interests`,
              nextRoute: `${routePrefix}/${route.params.id ||
                path}/audience/targeting-summary`,
              storeNamespace: "ads",
            }),
          },
          {
            path: "targeting-summary",
            component: () =>
              import("@/views/audiences/edit/targeting/TargetingSummary.vue"),
            meta: {
              title: "Cílení - Shrnutí",
              nestedMode: true,
              drawerItems,
            },
            props: route => ({
              id: route.params.id || null,
              prevRoute: `${routePrefix}/${route.params.id ||
                path}/audience/targeting-excluded-interests`,
              nextRoute: `${routePrefix}/${route.params.id || path}/ad/general`,
              targetingBasicsRoute: `${routePrefix}/${route.params.id ||
                path}/audience/targeting-basics`,
              targetingInterestsRoute: `${routePrefix}/${route.params.id ||
                path}/audience/targeting-interests`,
              targetingExcludedInterestsRoute: `${routePrefix}/${route.params
                .id || path}/audience/targeting-excluded-interests`,
              storeNamespace: "ads",
            }),
          },
        ],
      },
      {
        path: "ad",
        component: RouterView,
        children: [
          {
            path: "",
            redirect: "general",
          },
          {
            path: "general",
            component: () => import("@/views/ads/edit/AdGeneral.vue"),
            meta: {
              nestedMode: true,
              drawerItems,
            },
            props: route => ({
              id: route.params.id || null,
              prevRoute: `${routePrefix}/${route.params.id ||
                path}/audience/targeting-summary`,
              nextRoute: `${routePrefix}/${route.params.id || path}/ad/design`,
              storeNamespace: "ads",
            }),
          },
          {
            path: "design",
            component: () => import("@/views/ads/edit/AdDesign.vue"),
            meta: {
              nestedMode: true,
              drawerItems,
            },
            props: route => ({
              id: route.params.id || null,
              nextRoute: `${routePrefix}/${route.params.id || path}/budget`,
              prevRoute: `${routePrefix}/${route.params.id || path}/ad/general`,
              storeNamespace: "ads",
            }),
          },
        ],
      },
      {
        path: "budget",
        component: () => import("@/views/ads/edit/AdBudget.vue"),
        meta: {
          nestedMode: true,
          drawerItems,
        },
        props: route => ({
          id: route.params.id || null,
          nextRoute: `${routePrefix}/${route.params.id || path}/summary`,
          prevRoute: `${routePrefix}/${route.params.id || path}/ad/design`,
          storeNamespace: "ads",
        }),
      },
      {
        path: "summary",
        component: () => import("@/views/ads/edit/AdSummary.vue"),
        meta: {
          nestedMode: true,
          drawerItems,
        },
        props: route => ({
          id: route.params.id || null,
          nextRoute: null,
          prevRoute: `${routePrefix}/${route.params.id || path}/budget`,
          storeNamespace: "ads",
        }),
      },
    ],
  }
}

const drawerItems = [
  {
    title: "Základní informace",
    route: "/ads/new/basics",
    submenu: [],
  },
  {
    title: "Vytvoření publika",
    route: "/ads/new/audience",
    submenu: [
      {
        title: "Druh publika",
        route: "/ads/new/audience/type",
      },
      {
        title: "Základní údaje",
        route: "/ads/new/audience/targeting-basics",
      },
      {
        title: "Detailní zacílení",
        route: "/ads/new/audience/targeting-interests",
      },
      {
        title: "Vyloučené zacílení",
        route: "/ads/new/audience/targeting-excluded-interests",
      },
      {
        title: "Shrnutí publika",
        route: "/ads/new/audience/targeting-summary",
      },
    ],
  },
  {
    title: "Reklama",
    route: "/ads/new/ad",
    submenu: [
      {
        title: "Obecné nastavení",
        route: "/ads/new/ad/general",
      },
      {
        title: "Návrh",
        route: "/ads/new/ad/design",
      },
    ],
  },
  {
    title: "Rozpočet",
    route: "/ads/new/budget",
    submenu: [],
  },
  {
    title: "Publikování",
    route: "/ads/new/summary",
    submenu: [],
  },
]

export default [
  {
    path: "",
    component: () => import("@/views/ads/AdsIndex.vue"),
  },
  getRoutes("new"),
  getRoutes(":id"),
]
